import { Box, Paper, Typography } from "@mui/material";
import { Person as PersonType } from "../../api";

type FormattedSummaryProps = {
	standalone: boolean;
	personInfo: PersonType;
};

const FormattedSummary = ({ standalone, personInfo }: FormattedSummaryProps) => {
	const content = (
		<Box sx={{ p: 1 }} data-component="formatted-summary-box">
			<Typography
				variant="body2"
				color="text.primary"
				sx={{ lineHeight: 1.6 }}
				dangerouslySetInnerHTML={{
					__html: personInfo.summary?.replaceAll("\n", "<br/>"),
				}}
				data-component="formatted-summary-text"
			/>
		</Box>
	);

	return (
		<>
			{!standalone ? (
				content
			) : (
				<Paper
					sx={{
						backgroundColor: (theme) => theme.palette.background.paper,
						minHeight: 50,
					}}
					data-component="formatted-summary-paper"
				>
					{content}
				</Paper>
			)}
		</>
	);
};

export default FormattedSummary;
